<template>
    <div class="trigger-container" :style="el.getStyle()" :class="el.getAnimationClass(currentElementIndex)" @mousedown="eventDrag($event, el.previewId)">
        <template v-if="el.Contents && el.Contents.length > 0">
            <component v-for="(media, index) in el.Contents" :key="index" class="media-element" :is="media.objectType" :el="media"/>
        </template>
        <div v-else class="empty-container-message">
            <span>"{{ el.Name }}"<br/><strong>vide</strong></span>
            <span class="indication">(les éléments vide ne seront pas affichés)</span>
        </div>
        <div class="shadow-select"></div>
        <div class="trigger-left" @mousedown="eventResize($event, el.previewId, 'left')"></div>
        <div class="trigger-right" @mousedown="eventResize($event, el.previewId, 'right')"></div>
        <div class="trigger-top" @mousedown="eventResize($event, el.previewId, 'top')"></div>
        <div class="trigger-bottom" @mousedown="eventResize($event, el.previewId, 'bottom')"></div>
        <div class="trigger-top-left" @mousedown="eventResize($event, el.previewId, 'top-left')"></div>
        <div class="trigger-top-right" @mousedown="eventResize($event, el.previewId, 'top-right')"></div>
        <div class="trigger-bottom-left" @mousedown="eventResize($event, el.previewId, 'bottom-left')"></div>
        <div class="trigger-bottom-right" @mousedown="eventResize($event, el.previewId, 'bottom-right')"></div>
    </div>
</template>

<script>
import DynamicImage from "./image.vue"
import ImageElement from "./image.vue"
import TextElement from "./text.vue"
import ColorElement from "./color.vue"
import VideoElement from "./video.vue"
import BasePreviewComponents from "./base/basePreviewComponents.vue";
import DiaporamaElement from "./diaporama.vue"
import GridElement from "./grid.vue"
export default {
    name: 'ContainerItem',
    extends: BasePreviewComponents,
    components: {
        DynamicImage,
        ImageElement,
        TextElement,
        ColorElement,
        VideoElement,
        DiaporamaElement,
        GridElement
    },
    data() {
        return {
        }
    },
    computed: {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    watch: {
    },
    methods: {
    }
}
</script>

<style scoped>
.shadow-select {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom: 0;
    opacity: 0;
    transition: all 0.5s ease;
    box-shadow: inset 0 0 20px 10px rgba(59, 130, 246,1);
    pointer-events: none;
}

.trigger-container.selected .shadow-select {
    opacity: 1;
}

.empty-container-message {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #ffffff;
    background: #0000ff3b;
    font-size: 50px;
    font-style: italic;
    text-align: center;
    padding: 1rem;
}

.empty-container-message > span{
        pointer-events: none;
      -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}

.indication {
    font-size: 35px;
    font-style: italic;
}
</style>
